import React, { forwardRef } from 'react';
import { Popper, MenuList as MuiMenuList, Fade } from '@mui/material';
import { withStyles } from '@mui/styles';
import { noop } from 'lodash';

export const menuListStyles = {
  backgroundColor: '#fff',
  boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  borderRadius: 4,
  padding: '0 !important',
  overflowX: 'hidden',
};

const MenuList = withStyles({
  root: menuListStyles,
})(MuiMenuList);

const Menu = forwardRef(
  (
    {
      className,
      children,
      open,
      anchorEl,
      placement,
      style,
      onListMouseEnter,
      onListMouseLeave,
      modal = false,
      keepMounted,
      onClose,
    },
    ref,
  ) => (
    <Popper
      className={className}
      sx={{
        zIndex: modal ? 1300 : 1000,
        width: 220,
        maxHeight: '90dvh',
        overflow: 'auto',
      }}
      open={open}
      anchorEl={anchorEl}
      style={style}
      placement={placement}
      transition
      keepMounted={keepMounted}
      onClose={onClose}
      ref={ref}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={200}>
          <MenuList onMouseEnter={onListMouseEnter} onMouseLeave={onListMouseLeave}>
            {children}
          </MenuList>
        </Fade>
      )}
    </Popper>
  ),
);

Menu.defaultProps = {
  open: false,
  onClose: noop,
};

export default Menu;
